import ToolTip from "components/design/toolTip";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { Files } from "components/icons/Files";
import { formatNumber } from "utils/formatNumber";

export const DftFilingDraftCardBody = ({
  approveStatus,
  rejectionReason,
  taxAmountPayable,
}: {
  approveStatus: boolean | null;
  rejectionReason: string;
  taxAmountPayable: number;
}) => {
  if (approveStatus)
    return (
      <div className="t-flex t-gap-2.5 t-items-center t-justify-between">
        <div className="t-flex t-gap-2.5 t-items-center">
          <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
            <div className="t-text-text-30 -t-mt-0.5">
              <Files />
            </div>
          </div>
          <div>
            <div className="t-text-body-sm t-text-text-30 t-font-light">
              Tax payable
            </div>
            <div className="t-text-subtext t-text-text-60">
              ${formatNumber(taxAmountPayable)}
            </div>
          </div>
        </div>
        <Tag tagType="green" icon={false} rounded size="small">
          Approved
        </Tag>
      </div>
    );

  if (approveStatus === false) {
    return (
      <div className="t-space-y-4">
        <div className="t-flex t-gap-2.5 t-items-center t-justify-between">
          <div className="t-flex t-gap-2.5 t-items-center">
            <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
              <div className="t-text-text-30 -t-mt-0.5">
                <Files />
              </div>
            </div>
            <div>
              <div className="t-text-body-sm t-text-text-30 t-font-light">
                Tax payable
              </div>
              <div className="t-text-subtext t-text-text-60">
                ${formatNumber(taxAmountPayable)}
              </div>
            </div>
          </div>
          <Tag tagType="red" icon={false} rounded size="small">
            Rejected
          </Tag>
        </div>
        {rejectionReason && (
          <div className="t-p-2 t-rounded t-bg-surface-lighter-grey t-space-y-2 t-border t-border-solid t-border-surface-grey">
            <div className="t-text-body-sm t-text-text-60">Reason</div>
            <div className="t-text-body-sm t-text-text-30">
              {rejectionReason}
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="t-flex t-gap-2.5 t-items-center t-justify-between">
      <div className="t-flex t-gap-2.5 t-items-center">
        <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
          <div className="t-text-text-30 -t-mt-0.5">
            <Files />
          </div>
        </div>
        <div>
          <div className="t-text-body-sm t-text-text-30 t-font-light">
            Tax payable
          </div>
          <div className="t-text-subtext t-text-text-60">
            ${formatNumber(taxAmountPayable)}
          </div>
        </div>
      </div>
      <Tag tagType="orange" icon={false} rounded size="small">
        Pending review
      </Tag>
    </div>
  );
};
